export enum recruitmentsStepTwoTypes {
  FETCH_RECRUIMENTS_STEP_TWO_REQUEST = "FETCH_RECRUIMENTS_STEP_TWO_REQUEST",
  FETCH_RECRUIMENTS_STEP_TWO_SUCCESS = "FETCH_RECRUIMENTS_STEP_TWO_SUCCESS",
  FETCH_RECRUIMENTS_STEP_TWO_FAILURE = "FETCH_RECRUIMENTS_STEP_TWO_FAILURE",
}